import {IndexedDbFactory} from "../database/IndexedDbFactory";
import {ServiceError} from "../../hooks/fetch/types";
import {M3uPlaylist} from "../../lib/m3u";


class PlaylistService {

    private static _instance: PlaylistService;

    private constructor() {
        //Private constructor to prevent direct instantiation
    }

    public static get Instance()
    {
        return this._instance || (this._instance = new this());
    }

    public async getPlaylist(): Promise<M3uPlaylist> {
        try {
            const data = await IndexedDbFactory.getInstance().get<M3uPlaylist>("keyvalue", "playlist");
            if (!data) {
                throw new ServiceError(404, 'Not Found', 'No playlist found');
            }
            return data;
        } catch (error) {
            if (error instanceof ServiceError) {
                throw error;
            }
            const message = error instanceof Error ? error.message : String(error);
            throw new ServiceError(500, 'Internal Error', message);
        }
    }

    public async countChannelsInPlaylist(): Promise<number> {
        try {
            const data = await IndexedDbFactory.getInstance().get<M3uPlaylist>("keyvalue", "playlist");
            if (!data) {
                return 0;
            }
            return data.medias.length;
        } catch (error) {
            const message = error instanceof Error ? error.message : String(error);
            throw new ServiceError(500, 'Internal Error', message);
        }
    }

    public async save(playlist: M3uPlaylist): Promise<void> {
        try {
            await IndexedDbFactory.getInstance().set("keyvalue", playlist, "playlist");
        } catch (error) {
            const message = error instanceof Error ? error.message : String(error);
            throw new ServiceError(500, 'Internal Error', message);
        }
    }

    public async remove(): Promise<void> {
        try {
            await IndexedDbFactory.getInstance().delete("keyvalue", "playlist");
        } catch (error) {
            const message = error instanceof Error ? error.message : String(error);
            throw new ServiceError(500, 'Internal Error', message);
        }
    }
}

export const playlistService = PlaylistService.Instance;
